import { UserType } from '../../entities/tenant/user.type';
import { AppSecurityRight } from '../modules/app.security';
import { ConfigurationSecurityRight } from '../modules/configuration.security.module';
import { withDerivedCrmRecordRights } from '../modules/crm.record.rights';
import { CrmSecurityRight } from '../modules/crm.security.module';
import { DashboardSecurityRight } from '../modules/dashboard.security.module';
import { JobSecurityModule, JobSecurityRight } from '../modules/job.security.module';
import { withDerivedJobSectionRights } from '../modules/job.section.rights';
import { SchedulerSecurityRight } from '../modules/scheduler.security.module';
import { SecurityRole, SecurityRoleType } from '../security.role';

export class EmployeeScheduler implements SecurityRole {

    _id = 'ef7f0f4b-815f-41eb-82d8-eae947284de9';
    system = true;
    hidden = false;
    name = SecurityRoleType.EmployeeScheduler;
    type = UserType.Employee;
    description = 'Can manage customers, manage jobs and schedule';
    rights = withDerivedCrmRecordRights(withDerivedJobSectionRights([
        AppSecurityRight.LoginWeb,

        SchedulerSecurityRight.CanAccess,
        SchedulerSecurityRight.ManageAppointments,
        SchedulerSecurityRight.ManageRunSheets,
        SchedulerSecurityRight.ManageOtherUserResourceGroups,
        SchedulerSecurityRight.ManageFieldAllocations,

        ConfigurationSecurityRight.AccessMetadata,
        ConfigurationSecurityRight.AccessPricing,
        ConfigurationSecurityRight.AccessTemplates,

        ConfigurationSecurityRight.ManageMetadata,
        ConfigurationSecurityRight.ManagePricing,
        ConfigurationSecurityRight.ManageTemplates,

        // MarkFinanceLock excluded: marking a job or stage Non-Billable / Non-Payable zeroes every line
        // under it, so it ships granted to no seeded role and a consultant enables it per role.
        // ChangeJobStructure excluded: a job's structure decides its stages and scheduling, so only an
        // administrator overrides or converts it by default and a consultant enables it per role.
        ...new JobSecurityModule().allExceptRights([JobSecurityRight.ModifyJobAfterFinalise, JobSecurityRight.ReverseWorkOrderStatus, JobSecurityRight.AccessQuote, JobSecurityRight.ManageQuote, JobSecurityRight.ModifyLockedItems, JobSecurityRight.MarkFinanceLock, JobSecurityRight.ApprovePendingItems, JobSecurityRight.ChangeJobStructure, JobSecurityRight.CompleteStagesWithUnresolvedTasks]),

        CrmSecurityRight.CanAccess,
        CrmSecurityRight.ManageEmployees,

        // DashboardSecurityRight.CanViewSystemDashboards,
        DashboardSecurityRight.CanCreateDashboards,

    ]));
}

